import type { Locale } from '@change-corgi/config/locales';

import __json from '../config/tiktok.json';

type CountryData =
	| string
	| Readonly<{
			handle: string;
			localesOverrides?: Readonly<Record<Locale, string>>;
	  }>;

type DataFromJson = Readonly<{
	handles: Readonly<Record<string, CountryData>>;
	defaultHandle: string;
}>;

const data: DataFromJson = __json;

export function getTiktokHandle({ locale, countryCode }: { locale?: Locale; countryCode: string }): string {
	const countryConfig = data.handles[countryCode];
	if (!countryConfig) {
		return data.defaultHandle;
	}
	if (typeof countryConfig === 'string') {
		return countryConfig;
	}
	if (!locale || !countryConfig.localesOverrides || !countryConfig.localesOverrides[locale]) {
		return countryConfig.handle;
	}
	return countryConfig.localesOverrides[locale];
}
